module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle "
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N HOUR AND THREE DRINKS")]), _vm._v(" into his latest visit to Mr. Mach’s Zero Room, Harkness still can’t escape the roaring Turnpike. It’s asking a lot of a four-dollar whiskey special. He stares across the bar and wonders how he ended up here with the drunken secretaries, hipsters slumming it, and Joseph “Joey Ink” Incagnoli, an ancient North End felon drinking Cynar and soda and reading the "), _c('em', [_vm._v("Herald")]), _vm._v(" in a corner booth. It’s not a hard question. Almost everyone in Boston knows the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Thalia nudges his shoulder as she walks past. “Too much thinking, champ.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He looks up. “Can’t help it.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("“Turnpike Toreador?”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He nods.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Thalia shuts her eyes. “Forget. Him.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“First anniversary.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Of what?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You know.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Accidents happen every day. Let it go, Eddy. Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The restaurant flickers, orange as a broiler. The drinkers at the bar, the couples eating bowls of "), _c('em', [_vm._v("phở")]), _vm._v(" at the half-empty tables beyond the murky fish tank that divides the bar from the restaurant—they’re all staring.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness blinks. “What’re they looking at?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Our customers don’t tend to like cops, Eddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m off duty.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I still don’t think it was such a good idea to wear your uniform,” Thalia says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Didn’t have time to change after work.” His dark green Nagog Police uniform makes Harkness look more like a forest ranger than a cop.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What time’d your shift end?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Nine,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Where’ve you been?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Playing in traffic.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("She shakes her head. “Not supposed to do that. Didn’t your mother tell you?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Can’t help it.” The room spins a little and Harkness shuts his eyes for a moment to slow it. “It’s just too much fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Count your blessings, Eddy. Be glad it wasn’t you who ended up dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Maybe it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Shut the fuck up.” Thalia leans closer. “That’s bullshit and you know it. You know, you really should drink more. Works for me when there’s something I need to chase out of my head.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Like my week in lockup before Mach’s lawyer bailed me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Told you before . . . ,” Harkness says, “I was just doing my job.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And now I’m doing mine.” Thalia fills his glass with whiskey and moves on.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center graphic break"
  }, [_vm._v("· · ·")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("After the beat cops cuffed Thalia and the other bartenders, they dragged them out of the Zero Room and into a van bound for Central Processing. Half were illegals; most of the rest had priors and outstanding warrants or drugs in their underwear or stuck in the toes of their Chuck Taylors. Only Thalia was clean. They locked eyes for a moment when Harkness walked in, wondering what a red-haired art girl in black jeans and a vintage Sonic Youth T-shirt was doing tending bar in a dump like the Zero Room. But he wasn’t at Mr. Mach’s to make new friends.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The Boston cops from District A-1 had raided the place and called in Narco-Intel when they couldn’t find what they were after. Harkness walked through the bar, getting a read on it. He started at the cash register. Mach seemed organized, the kind of guy who kept his valuables together—keys and cell phone, wallet and Ray-Bans, drugs and money. Harkness trailed his fingers along the red leather barstools and set them spinning.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The stool closest to the register was scuffed with tiny white scratches, almost invisible in the dark bar. Harkness jumped up on it, boots scraping the leather, and pushed up a stained ceiling tile.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("A BPD lifer named O’Rourke pointed his flashlight up into the ceiling to reveal wires and a metal duct.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Thanks for finding the ventilation system,” Sergeant O’Rourke said. “Was getting kind of toasty in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness held up his right hand to quiet the smart-ass, then let it move toward the duct like a dowsing rod, his fingers running along the cool aluminum until they found the smudged edge. He peeled back a piece of silver tape, then ripped the metal duct open—a little at first, then more, until the flashlight revealed dozens of foil-wrapped bricks.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("O’Rourke’s eyes popped open. “Holy crap.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("At a sidewalk shooting in Dorchester or a drug dealer’s triple-decker in Mission Hill, Harkness could find the drugs, guns, money, shell casings, and tossed cell phones. It wasn’t supernatural. Harkness didn’t need any help from the spirit world.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("From where he sits, a few barstools to the right, Harkness can still see the stained tile that once hid ten kilos of cocaine. But there’s nothing to find up there now. After two years in Walpole, his sentence reduced by ratting out his supplier, Mr. Mach’s done with drugs, Thalia says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He’s moved on to something worse.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center graphic break"
  }, [_vm._v("· · ·")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“Hey!” Thalia’s waving her hand in front of his face. “You okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Peachy.” Harkness stands but the room starts to twist, and he sinks back down on his barstool.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Everything okay?” Mr. Mach appears behind the bar beaming like a good citizen of Chinatown, the kind who funds scholarships and builds parks.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Sure.” Thalia gives a frozen smile.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Like her?” Mr. Mach asks Harkness, as if Thalia’s invisible. “Think she might make a good girlfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I do,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“My best waitress ever. So sorry to see her go.” Mach smiles, teeth yellow as old dominos. With his shiny black hair combed back and his crisp blue suit, he looks handsome and presidential. Harkness can picture his face on a cheap coin.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No way.” Thalia throws a bar rag on the floor with a wet slap loud enough to stir even the deepest drinkers.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Had enough. No more cop friends here.” Mach points at Harkness. “Especially this one"), _c('em', [_vm._v(".")]), _vm._v(" Very bad luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“He was just leaving,” Thalia says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You leave, too.” Mach points at the door. “Get out. Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Thalia stares at her boss for a moment. She’s a tough girl from Worcester, her sharp edges even sharper after years working in one of Chinatown’s last dive bars. But there’s no negotiating with Mr. Mach.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Thalia grabs her leather jacket and cigarettes. She raises the hinged wooden section of the bar, walks through, and lets it slam down behind her with a loud crack. Everyone in the Zero Room turns to watch another late-night drama unfold under the neon.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Come on, Eddy,” she says. “Let’s get out of this shithole.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("As they walk across a galaxy of cigarette burns and carpet stains, Harkness waves at the roomful of night creatures like a celebutard taking a star turn. Because that’s what he’s become.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness turns at the door. “Hey, Mach. Can I see your "), _c('em', [_vm._v("special menu")]), _c('em', [_vm._v("?")]), _vm._v("” He points to the end of the bar, where creeps in suits leaf through thick black binders.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Mach shows his bad teeth and stabs the air with his finger. “Special menu is for people who don’t have girlfriends.” Then he points at Thalia. “You get sick of her, bring her back. Then you see special menu.”")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“Thanks for getting me fired,” Thalia says when they’re on the street.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Sorry.” Harkness pulls his Sox jacket over his uniform and looks up at the spinning stars. “He’ll rehire you. Likes you.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Thalia shakes her head. “The guy’s a psycho. I’m sick of his shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They walk down Beach Street past closed restaurants, windows jammed with faded lunch menus and deflated Peking ducks hanging from greasy hooks.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What the hell was his problem tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No idea,” Thalia says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Why’d he fire you?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Because he thinks I’m your girlfriend now, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Maybe you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“For five hundred bucks, you could spend the night with your very own underage Thai girl,” Thalia says. “Don’t forget—virgins cost extra.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t have that kind of money anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Thalia kicks Harkness.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I mean, no thanks.” Harkness imagines the warren of rooms facing the street—stained futons, sweet stink of rancid sesame oil, padlocks on the doors, the giant red "), _c('em', [_vm._v("0")]), _vm._v(" of the Zero Room’s sputtering neon sign glowing through a grid of chicken wire. “Soon as I’m back in Boston,” he says, “I’ll make sure Mach gets brought down again. For good, this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You sure about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Absolutely. Second time’s the charm.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That’s great.” Thalia puts out her hand. “But tonight I’m driving, champ. You’re kind of drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness drops the keys in her palm. “Don’t smash it up, girlfriend.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f7658e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 75
// module chunks = 0